import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import RoutesPaths from "./routes/index";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Error from "../Components/404/PageNotFound";
import { getToken, RESTRICTED_STAFF_ID } from "../Components/Utils/util";
import { getProfile } from "../Components/Redux/Action";

// ScrollToTop Component
const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return children;
};

// FinalRoute Component for Authorization
const FinalRoute = React.memo(({ route }) => {
  const location = useLocation();
  const userToken = getToken();
  const allowedRoles = route?.meta?.roles || [];
  const requiredAccessKeys = route?.meta?.accessKeys || [];
  const storedStaffId =
    typeof window !== "undefined" ? localStorage.getItem("staffId") : null;
  const authenticatedStaffId = storedStaffId || userToken?.staffId || "";
  const isRestrictedStaff = authenticatedStaffId === RESTRICTED_STAFF_ID;
  const isBlogRoute =
    typeof route?.path === "string" &&(
    route.path.toLowerCase().includes("blog") || route.path.toLowerCase().includes("tourist-places") || route.path.toLowerCase().includes("update-place") || route.path.toLowerCase().includes("create-place") || route.path.toLowerCase().includes("package") || route.path.toLowerCase().includes("place") || route.path.toLowerCase().includes("update-package") || route.path.toLowerCase().includes("create-package") || route.path.toLowerCase().includes("sitemap")
  );

  const hasAccessKey = requiredAccessKeys.some(
    (key) => userToken?.access?.[key] === 1
  );

  if (
    isRestrictedStaff &&
    route?.meta?.authRoute &&
    !isBlogRoute
  ) {
    return (
      <Navigate
        to="/blog/list"
        replace={true}
        state={{ path: location?.pathname }}
      />
    );
  }

  // Authorization Logic
  if (route?.meta?.authRoute) {
    if (requiredAccessKeys.length > 0) {
      if (
        userToken?.role === 1 ||
        (allowedRoles.includes(userToken?.role) && (hasAccessKey || (isRestrictedStaff && isBlogRoute)))
      ) {
        return <route.component />;
      }
    } else if (allowedRoles.includes(userToken?.role)) {
      return <route.component />;
    }

    // Unauthorized
    return (
      <Navigate to="/" replace={true} state={{ path: location?.pathname }} />
    );
  }

  // Unrestricted Access
  return <route.component />;
});

// Main Router Component
const Router = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userAuthToken = getToken();
  useEffect(() => {
    const loadUserProfile = async () => {
      try {
        await dispatch(getProfile(navigate));
      } catch (error) {
        console.error("Error fetching user profile:", error);
        navigate("/");
      }
    };
    if (userAuthToken) {
      loadUserProfile();
    }
  }, [dispatch, navigate, userAuthToken]);

  return (
    <ScrollToTop>
      <Routes>
        {RoutesPaths.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<FinalRoute route={route} />}
          >
            {route.children &&
              route.children.map((childRoute, childIndex) => (
                <Route
                  key={childIndex}
                  path={childRoute.path}
                  element={<FinalRoute route={childRoute} />}
                />
              ))}
          </Route>
        ))}
        <Route path="*" element={<Error />} />
      </Routes>
    </ScrollToTop>
  );
};

export default Router;
